import type { GetAuthSessionResponse } from '@models/auth.models';
import { api } from '@store/api';

export const authApi = api.injectEndpoints({
  endpoints: builder => ({
    getAuthSession: builder.query({
      query: () => ({
        url: `/auth/session`,
      }),
      transformResponse: (response: GetAuthSessionResponse) => response.data,
    }),
  }),
});

export const { useGetAuthSessionQuery } = authApi;
